import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Enrollment, EnrollmentCompact } from '../../lib/types/models/enrollment/enrollment'
import { EnrollmentFilter } from '../../lib/types/models/enrollment/enrollment-filter'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type EnrollmentVersionMap = {
  FULL: Enrollment
  COMPACT: EnrollmentCompact
}

export function getAffectedStaffEnrollments<T extends keyof EnrollmentVersionMap>(
  id: number,
  input: PaginationRequest<EnrollmentFilter, string, T> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.affectedStaffs.getAffectedStaffEnrollments.url, { id }),
        input
      )
    )
    .get<PaginationResponse<EnrollmentVersionMap[T]>>()
}
